import { AboutImage } from "./AboutImage";
import { AboutContent } from "./AboutContent";

export const About = ({ data }) => {
  return (
    <div id="about">
      <span className="aboutAnchor" id="aboutAnchor" aria-hidden="true"></span>
      <div className="container">
        <div className="row">
          <AboutImage />
          <AboutContent data={data} />
        </div>
      </div>
    </div>
  );
};
